export type BodyAverageDwellTime = {
  Tipo_consulta_BD: 'RANGO_DIAS';
  fecha_inicial: string;
  fecha_final: string;
  sucursal: string;
};

export interface ResponseAverageDwellTime {
  tipo:  string;
  horas: HourlySummary[];
}

export interface HourlySummary {
  hora:            string;
  placas:          string[];
  total_vehiculos: number;
}
